export default __webpack_public_path__ + "static/media/gianaurelio-cuniberti.23c45eac.png";